import { createSelector } from 'reselect';

const homeSignInNagSelector = state => state.homeSignInNag;

export const selectHomeSignInNagShowSmallSignInNag =
  createSelector(homeSignInNagSelector, (homeSignInNag = {}) =>
    homeSignInNag.showSmallSignInNag);

export const selectHomeSignInNagShowLargeSignInNag =
  createSelector(homeSignInNagSelector, (homeSignInNag = {}) =>
    homeSignInNag.showLargeSignInNag);

export const selectHomeSignInNagRenderLargeSignInNagWithAnimation =
  createSelector(homeSignInNagSelector, (homeSignInNag = {}) =>
    homeSignInNag.renderLargeSignInNagWithAnimation);
